import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { getStorage } from '../../utils';

import constant from '../../constant';
import Logo from './../../assets/img/logo.png'
import ChangePasswordButton from '../profile/ChangePasswordButton';
import { CustomChatButton } from '../chat/ChatButton';

function SideBar(props: any) {
    const [sidebarVisibility, setSidebarVisibility] = useState('none');
    const { loanList, activeLoanId, onChangeActiveLoanId, unreadMessageCountList, socket } = props;
    const ud = getStorage(constant.key.userDetail);
    const toggleSideBarVisibility = () => {
        if (sidebarVisibility === 'none') {
            setSidebarVisibility('block');
            $('.sidebar').css('display', 'block');
        }
        else {
            setSidebarVisibility('none');
            $('.sidebar').css('display', 'none');
        }
    }
    return (
        <React.Fragment>
            <div className="mobile-menu" onClick={() => toggleSideBarVisibility()}>
                {
                    sidebarVisibility === 'none'
                        ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                        </svg>
                        : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                }
            </div>
            <div className="sidebar">
                <div className="sidebar-header text-center">
                    <img className="logo" src={Logo} alt="logo" />
                    <div className="mt-3 text-left">
                        <span>
                            <a href="tel:718-851-2222" rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="mr-2 h-1">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                </svg>

                                        718.851.2222</a>
                        </span><br />
                        {/* <span>
                            <a href="https://goo.gl/maps/uPARecxWn9VPh1tH7" target="_blank" rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-1 mr-2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                </svg>

                                        Address
                                    </a>
                        </span><br /> */}
                        <span>
                            <a href="https://capitalplusres.com" target="_blank" rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-1 mr-2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
                                </svg>
                                        capitalplusres.com
                                    </a>
                        </span><br />
                        <small>
                            Capital Plus Residential NMLS #: 1404226<br />
                            1413-1425 38th Street, Suite 201<br />
                            Brooklyn, NY 11218
                            <a href="https://goo.gl/maps/uPARecxWn9VPh1tH7" target="_blank" rel="noreferrer" className="ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-1 mr-1">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                </svg>
                                Google Map
                            </a>
                        </small>
                    </div>
                </div>
                <div id="sidbar-main" style={{
                    display: 'flex', flexDirection: 'column',
                    // justifyContent: 'center', alignItems: 'flex-start',
                    // overflow: 'hidden', overflowY: 'scroll'
                    // paddingTop: '1rem', paddingBottom: '1rem',
                    // overflowY: 'scroll', height: '100%',
                    margin: '1rem 0px',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap',
                    overflowX: 'auto'
                }}>
                    {
                        loanList && loanList.map((item: any, index: number) => {
                            const isActive = activeLoanId === item.loanId;
                            const buttonCSS = isActive ? "btn btn-link p-0 font-weight-bold" : "btn btn-link p-0";
                            const unreadMessageCount = getUnreadMessageCount(item.id);

                            return (
                                <div className="p-3 br-3 w-100 mb-3" key={index} style={{ backgroundColor: '#e4f8ff', border: isActive ? '1px dashed #023c5b' : '1px dashed #e4f8ff' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <button type="button" onClick={(e: any) => onChangeActiveLoanId(item.loanId)} className={buttonCSS}>{item.loanId}</button>

                                        <CustomChatButton css={unreadMessageCount > 0 ? "blink btn btn-link text-danger mr-2 p-0 position-relative" : "btn btn-link text-primary mr-2 p-0 position-relative"} id={item.id} socket={socket}>
                                            <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1.6rem' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
                                            </svg>

                                            {unreadMessageCount > 0 && <div style={{ position: 'absolute', background: 'red', borderRadius: '50%', height: '0.5rem', width: '0.5rem', top: 3, right: -4 }}></div>}
                                        </CustomChatButton>
                                    </div>
                                    <div>
                                        <small>{item.subjectPropertyStreet}</small>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <small>$ {parseFloat(item.loanAmount).toLocaleString(undefined, { minimumFractionDigits: 2 })}</small>
                                        <small style={{ color: item.statusBackgroundColor }}>{item.statusName}</small>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div id="sidebar-footer">
                    <div className="text-muted mb-2" style={{ lineHeight: '1rem' }}>
                        {ud.name}<br />
                        <small>{ud.email}</small>
                    </div>
                    <div>
                        <ChangePasswordButton css="btn btn-link p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-1 mr-3">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
                            </svg>
                            Change Password
                        </ChangePasswordButton>
                    </div>
                    <div>

                        <Link className="text-danger" to={constant.component.logout.url}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-1 mr-3">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                            </svg>
                        Logout
                    </Link>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )

    function getUnreadMessageCount(loanDetailId: any) {
        const matchingRow = unreadMessageCountList.filter((i: any) => i.loanDetailId === loanDetailId);
        if (matchingRow.length > 0) {
            return parseFloat(matchingRow.length)
        } else {
            return 0
        }
    }
}

export default SideBar;